module.exports = __webpack_public_path__ + "static/media/video2-sunnybank.b31fc4fe.mp4";